import {GET_DAILY_ACTIVITY_SUCCESS} from "../../reducers/dailyActivityReducer";


export const getDailyActivitySuccess = (reports, loadMore, page) =>{

    return {
        type: GET_DAILY_ACTIVITY_SUCCESS,
        payload: {reports, loadMore, page}
    }
}